<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="openCardSourceForm(0)">新增</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" icon="el-icon-download" @click="exportList()">导出</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" icon="el-icon-delete" @click="removeCardSource(0)">删除</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" :model="formInline" size="mini" class="smui-form-right">
                <el-form-item label="卡源">
                  <el-input v-model="formInline.source_name" placeholder="用户名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="queryCardSourceList()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <div class="sanmuui-body-container">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="source_name"
                  label="用户"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="card_type"
                  label="账号"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="api_account"
                  label="API账号"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="api_password"
                  label="API密码"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注">
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="录入时间"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  label="操作"
                  width="300">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="openCardSourceForm(scope.row.source_id)">编辑</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="removeCardSource(scope.row.source_id)"
                      v-if="scope.row.hold_id!=1">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>

          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="500px">
        <el-form :model="formNew" :rules="rules" ref="formNew" label-width="80px" class="demo-form-inline" size="medium">
          <el-form-item label="卡源名称" :label-width="formLabelWidth" prop="source_name">
            <el-input v-model="formNew.source_name" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="API账号" :label-width="formLabelWidth" prop="api_account">
            <el-input v-model="formNew.api_account" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="API密码" :label-width="formLabelWidth" prop="api_password" v-if="displayPassword">
            <el-input v-model="formNew.api_password" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="卡类型" :label-width="formLabelWidth" prop="card_type">
            <el-dropdown size="small" type="default" @command="handleSelectCardType">
            <el-button type="default">
                {{formNew.card_type_text}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in card_type_options" :command="item">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input type="textarea" v-model="formNew.remark" class="-form2-input-text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="addCardSourceInfo('formNew')" size="small">确 定</el-button>
        </div>
    </el-dialog>

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'cardsource_manage',
  data() {
    return {
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      dailRepwdVisible: false,
      dialogTitle: "新增用户",
      formInline: {
        source_name: '',
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      card_type_options: [
        { value: '1', label: '移动卡' },
        { value: '2', label: '联通卡' },
        { value: '3', label: '海外卡' }
      ],
      displayPassword: false,
      formLabelWidth: "110px",
      formNew: {
        source_id: 0,
        source_name: "",
        api_account: "",
        api_password: "",
        card_type: 0,
        card_type_text: "请选择",
        remark: "",
      },
      rules: {
        source_name: [
          { required: true, message: '请输入卡源名称', trigger: 'blur' }
        ]
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      selectHoldId: 0,
      selectedHoldName: "",
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      selectUserId: 0,
      selectUserName: '',
      fmpwd: {
        password: '',
        repassword: '',
      }
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.queryCardSourceList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    refreshPageList: function() {
      this.queryCardSourceList();
    },
    queryCardSourceList: function() {
      this.loadingTableData = true;
      this.tableData = [];

      this.formInline.page_index = this.pagging.current_page;
      this.formInline.page_size = this.pagging.pager_size;
      Api.CardSourceList(this.formInline).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          // let startNum = (this.pagging.current_page - 1) * this.pagging.pager_size;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    exportList: function() {
      var argdata = {
        Name: this.formInline.name,
        containChildren: true,
        HoldID: this.selectHoldId
      };
      Api.Hold_ExportList(argdata).then(res => {
          if(!res)
            return;
          if(res.code != 200) {
            this.$message.error(res.msg);
          }
          if(res.data) {
            var hostStr = window.location.host;
            var my_request = hostStr.indexOf('gps881.com') > -1 ?
                `https://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}` :
                `http://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}`;
            window.open(my_request);
          } else {
            this.$message.error('无数据导出！');
          }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleSelectCardType: function(cmd) {
      this.formNew.card_type_text = cmd.label;
      this.formNew.card_type = parseInt(cmd.value);
    },
    resetFormSourceInfo: function() {
      this.formNew = {
        source_id: 0,
        source_name: "",
        api_account: "",
        api_password: "",
        card_type: 0,
        card_type_text: "请选择",
        remark: "",
      };
    },
    openCardSourceForm: function(id) {
      this.resetFormSourceInfo();
      this.formNew.source_id = id;
      this.dialogFormVisible = true;
      if(id > 0) {
        this.displayPassword = false;
        this.dialogTitle = "修改卡源";
        Api.CardSourceDetail({ source_id: id }).then(res => {
          if(res && res.code === 200 && res.data) {
            this.formNew.source_name = res.data.source_name;
            this.formNew.api_account = res.data.api_account;
            this.formNew.api_password = res.data.api_password;
            this.formNew.card_type = res.data.card_type;
            this.formNew.card_type_text = res.data.card_type && res.data.card_type > 0 ? this.card_type_options.find(x => x.value == res.data.card_type).label : "";
            this.formNew.remark = res.data.remark;
          } else {
            console.log(`获取sim卡资料没返回数据${res ? res.msg : ''}`);
            this.$message.error(`出错了！${res ? res.msg : ''}`);
          }
        });
      } else {
        this.displayPassword = true;
        this.dialogTitle = "新增卡源";
      }
    },
    addCardSourceInfo: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api.AddCardSource(this.formNew).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '恭喜你，提交成功！',
                type: 'success'
              });
              this.resetFormSourceInfo();
              this.dialogFormVisible = false;
              this.queryCardSourceList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    removeCardSource: function(id) {
      this.$confirm('此操作将删除该卡源, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        var masters = [];
        if(id == 0) {
          if(this.multipleSelection.length > 0) {
            this.multipleSelection.forEach(s => {
              masters.push(s.hold_id);
            });
          } else {
            this.$message({
                message: '请选择卡源',
                type: 'warning'
            });
            return;
          }
        } else {
          masters.push(id);
        }
         var argdata = {
            source_ids: masters
          };
          Api.RemoveCardSource(argdata).then(res => {
            if(!res)
              return;

            if(res.code === 200) {
                this.$message({
                    message: '已删除！',
                    type: 'success'
                });
                this.queryCardSourceList();
            } else {
                this.$message({
                    message: '删除失败！' + res.msg,
                    type: 'warning'
                });
            }
          });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 60 - 130;
    var h2 = document.body.clientHeight - 115;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.queryCardSourceList();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}
</style>